import { ReactElement } from 'react';
interface MyEquipmentFooterProps {
  children: ReactElement | ReactElement[];
}

export const MyEquipmentFooter = ({
  children
}: MyEquipmentFooterProps) => <div slot="footer">{children}</div>;
